<template>
  <component
    :is="name"
    v-if="loading || serviceUnavailable"
    :key="`observability${$route.name}${loading}`"
    :service-requested="serviceRequested"
    name="Observability"
  />
  <router-view v-else />
</template>
<script>
const RequestService = () => import('@/components/start/RequestService.vue')

export default {
  name: 'Observability',
  components: { RequestService },
  computed: {
    name() {
      if (this.serviceUnavailable) return 'request-service'
      return 'loading-page'
    },
    serviceUnavailable() {
      return this.$store.state.observability.serviceUnavailable
    },
    serviceRequested() {
      return this.$store.state.observability.serviceRequested
    },
    loading() {
      return false
    },
  },
  created() {
    this.$store.commit('observability/SET_SERVICE_UNAVAILABLE', { serviceUnavailable: false, serviceRequested: false })
  },
}
</script>
